import React from 'react';
import { useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import StatisticsTable from '../../components/StatisticsTable';
import {globalResourcesSelector} from '../../reducers/globalAdminStats/globalAdminStatsReducer';

const GlobalResources = ({ show, setShow }) => {
  const [ t ] = useTranslation();

  const headers = [
    t('globalResources.headers.Filesystem'),
    t('globalResources.headers.Mounted'),
    t('globalResources.headers.Used'),
    t('globalResources.headers.UsedPerc'),
    t('globalResources.headers.Available'),
    t('globalResources.headers.Total'),
  ];

  const globalResources = useSelector(globalResourcesSelector).map(row => Object.values(row));

  return (
    <>
      <Button variant="outline-dark" onClick={() => setShow(true)}>
        {t('globalResources.title')}
      </Button>

      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{t('globalResources.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="current-steps-statistics-table">
            <StatisticsTable
              tableHeaders={headers}
              tableData={globalResources}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GlobalResources;
